import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class YearValidator {
  /**
   * Minimum valid year (e.g., 1900)
   */
  static readonly MIN_YEAR = 1900;

  /**
   * Maximum valid year (current year + 1 for next year's models)
   */
  static get MAX_YEAR(): number {
    return new Date().getFullYear() + 1;
  }

  /**
   * Validator function for vehicle year
   * @param control - The form control to validate
   * @returns ValidationErrors | null
   */
  static vehicleYear(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // Let required validator handle empty values
    }

    const yearValue = control.value.toString().trim();
    
    // Check if it's a valid number
    if (!/^\d+$/.test(yearValue)) {
      return { 
        vehicleYear: { 
          value: yearValue,
          message: 'Year must be a valid number'
        } 
      };
    }

    const year = parseInt(yearValue, 10);
    
    // Check if year is within valid range
    if (year < YearValidator.MIN_YEAR || year > YearValidator.MAX_YEAR) {
      return { 
        vehicleYear: { 
          value: yearValue,
          message: `Year must be between ${YearValidator.MIN_YEAR} and ${YearValidator.MAX_YEAR}`
        } 
      };
    }

    return null; // Valid year
  }
}

/**
 * Factory function to create vehicle year validator
 * @returns ValidatorFn
 */
export function vehicleYearValidator(): ValidatorFn {
  return YearValidator.vehicleYear;
}

